import { Directive, ElementRef, Input, Renderer2, OnChanges, NgZone } from '@angular/core';

@Directive({
  selector: '[appCssValidationFormInput]'
})
export class CssValidationFormInputDirective implements OnChanges {
  @Input('appShowSuccess') showSuccess: boolean;
  @Input('appCssValidationFormInput') inputName: any;
  @Input('ngModel') ngModel;

  constructor(private el: ElementRef, private renderer: Renderer2, private zone: NgZone) {

  }

  ngOnChanges() {
    if (this.inputName.invalid) {
      this.renderer.addClass(this.el.nativeElement, "is-invalid");
      if ((<HTMLElement>this.el.nativeElement).classList.contains("is-valid"))
        this.renderer.removeClass(this.el.nativeElement, "is-valid");
    } else {
      if ((<HTMLElement>this.el.nativeElement).classList.contains("is-invalid"))
        this.renderer.removeClass(this.el.nativeElement, "is-invalid");
      if (this.showSuccess) {
        this.renderer.addClass(this.el.nativeElement, "is-valid");
      }
    }
  }
}
